// extracted by mini-css-extract-plugin
module.exports = {"cpgTabel":"CosplayersTable_cpgTabel__byTFy","overflow":"CosplayersTable_overflow__1pHn3"};